// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M9.5 16Q6.77 16 4.89 14.11T3 9.5 4.89 4.89 9.5 3 14.11 4.89 16 9.5Q16 10.6 15.65 11.58T14.7 13.3L20.3 18.9Q20.58 19.18 20.58 19.6T20.3 20.3 19.6 20.58 18.9 20.3L13.3 14.7Q12.55 15.3 11.57 15.65T9.5 16M9.5 14Q11.38 14 12.69 12.69T14 9.5 12.69 6.31 9.5 5 6.31 6.31 5 9.5 6.31 12.69 9.5 14"/>';

/** Search (actions). */
const icon: IconData = {
  id: "search",
  name: "Search",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: {
      svg: '<path d="M19.6 21L13.3 14.7Q12.55 15.3 11.57 15.65T9.5 16Q6.77 16 4.89 14.11T3 9.5 4.89 4.89 9.5 3 14.11 4.89 16 9.5Q16 10.6 15.65 11.58T14.7 13.3L21 19.6ZM9.5 14Q11.38 14 12.69 12.69T14 9.5 12.69 6.31 9.5 5 6.31 6.31 5 9.5 6.31 12.69 9.5 14"/>',
    },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M10.8 3.12L12.01 3.47 13.11 4.06 14.11 4.89 14.94 5.89 15.53 6.99 15.89 8.19 16 9.5 15.91 10.57 15.65 11.58 15.24 12.5 14.7 13.3 20.3 18.9 20.51 19.21 20.58 19.6 20.51 19.98 20.3 20.3 19.98 20.51 19.6 20.58 19.21 20.51 18.9 20.3 13.3 14.7 12.49 15.24 11.57 15.65 10.56 15.91 9.5 16 8.19 15.88 6.98 15.53 5.88 14.94 4.89 14.11 4.07 13.11 3.48 12.01 3.12 10.81 3 9.5 3.11 8.19 3.47 6.99 4.06 5.89 4.89 4.89 5.89 4.06 6.99 3.47 8.2 3.12 9.5 3Z"/></g><path d="M9.5 16Q6.77 16 4.89 14.11T3 9.5 4.89 4.89 9.5 3 14.11 4.89 16 9.5Q16 10.6 15.65 11.58T14.7 13.3L20.3 18.9Q20.58 19.18 20.58 19.6T20.3 20.3 19.6 20.58 18.9 20.3L13.3 14.7Q12.55 15.3 11.57 15.65T9.5 16M9.5 14Q11.38 14 12.69 12.69T14 9.5 12.69 6.31 9.5 5 6.31 6.31 5 9.5 6.31 12.69 9.5 14"/>',
    },
  },
  animation: () => import("../animations/search.js"),
};

export default icon;
